import { TypesRow } from "@/ServerTypes/Administration";
import { DocumentsService } from "@/ServerTypes/Cemdo";
import { DocumentLinkRow, DocumentLinkForm, DocumentLinkService } from "@/ServerTypes/Default";
import { DocumentFileEditor } from "@/Shared/DocumentManagementImports";
import { Decorators, EntityDialog, toId, tryFirst } from "@serenity-is/corelib";

@Decorators.registerClass('Profis.Default.DocumentLinkDialog')
export class DocumentLinkDialog extends EntityDialog<DocumentLinkRow, any> {
    protected getFormKey() { return DocumentLinkForm.formKey; }
    protected getIdProperty() { return DocumentLinkRow.idProperty; }
    protected getLocalTextPrefix() { return DocumentLinkRow.localTextPrefix; }
    protected getNameProperty() { return DocumentLinkRow.nameProperty; }
    protected getService() { return DocumentLinkService.baseUrl; }
    protected getDeletePermission() { return DocumentLinkRow.deletePermission; }
    protected getInsertPermission() { return DocumentLinkRow.insertPermission; }
    protected getUpdatePermission() { return DocumentLinkRow.updatePermission; }

    protected form = new DocumentLinkForm(this.idPrefix);

        public getToolbarButtons() {
            var buttons = super.getToolbarButtons().filter(x => x.cssClass == "save-and-close-button" || x.cssClass == "apply-changes-button" || x.cssClass == "delete-button");

            return buttons;
        }

    public afterLoadEntity() {
        super.afterLoadEntity();

        if (this.isNew && !this.entity.TypeId) {
            var defaultType = tryFirst(TypesRow.getLookup().items,
                x => x.DataClassName == "DocumentLink" && !!x.IsDefault);

            if (defaultType)
                this.form.TypeId.value = defaultType.TypeId.toString();
        }
        if (this.entity.Document1Id) {
            DocumentsService.Retrieve({
                EntityId: toId(this.entity.Document1Id)
            }, response => {
                (this.form.Document1Id as DocumentFileEditor).projectId = response.Entity.ProjectId;
                (this.form.Document1Id as DocumentFileEditor).value = response.Entity.DocumentId.toString();
                (this.form.Document2Id as DocumentFileEditor).projectId = response.Entity.ProjectId;
                (this.form.Document2Id as DocumentFileEditor).value = this.entity.Document2Id?.toString();

            }, {
                async: false
            });
        }
    }
}